import {
  Checkbox
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbsComponent from "../../../Components/BreadCrumbs";
import CustomButton from "../../../Components/CustomButton";
import LeftSideNav from "../../../Components/LeftSideNav";
import TopNavBar from "../../../Components/TopNavbar";
import Fonts from "../../../Config/Fonts";
import Strings from "../../../Config/Strings";
import { rolePermissionTableHeader } from "../../../Constants/MockData";
import { getAllModulesAPI } from "../../../Store/Action/rolePermissionAction";
import {
  addUserRolePermissionAPI,
  deleteUserRolePermissionAPI,
  getUserRolePermissionByIdAPI,
  updateUserRolePermissionAPI,
} from "../../../Store/Action/userRolePermissionAction";
import Colors from "../../../theme/Colors";

const getCheckboxValue = (moduleIndex, checkboxIndex) => {
  return moduleIndex * 4 + checkboxIndex + 1; // Example: moduleIndex * 4 + checkboxIndex + 1
};

const UserRolePermissionModuleList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { userRole } = location?.state || {};

  const [isEdit, setIsEdit] = useState(false);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [userRoleModuleName, setUserRoleModuleName] = useState([]);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState(new Set());
  const [initialCheckboxesState, setInitialCheckboxesState] = useState(new Set());

  useEffect(() => {
    setBreadcrumbs([
      { key: "1", href: "/", text: "Home" },
      { key: "2", href: "/masters", text: "Masters" },
    ]);
    dispatch(
      getUserRolePermissionByIdAPI(userRole?.user_id, (result) => {
        const permissionIds = result?.flatMap((item) => item?.permission_id); // Flatten the array if permission_id is an array of IDs
        if (permissionIds && permissionIds?.length > 0) {
          setIsEdit(true);
        } 
        setSelectedCheckboxes(new Set(permissionIds));
        setInitialCheckboxesState(new Set(permissionIds));
      })
    );
    dispatch(
      getAllModulesAPI({}, (result) => {
        setUserRoleModuleName(result?.data);
      })
    );
  }, [dispatch, navigate, userRole?.user_id]);


  const handleCheckboxChange = (event, moduleIndex, roleIndex) => {
    const isChecked = event.target.checked;
    const simpleId = getCheckboxValue(moduleIndex, roleIndex);
    setSelectedCheckboxes((prev) => {
      const newSelectedCheckboxes = new Set(prev);
      if (isChecked) {
        newSelectedCheckboxes.add(simpleId);
      } else {
        newSelectedCheckboxes.delete(simpleId);
      }
      return newSelectedCheckboxes;
    });
  };

  const onAddRolePermission = async () => {
    const addRolePermissionRequestData = {
      userId: userRole?.user_id,
      role_id: userRole?.user_role_id,
      permission_id: Array.from(selectedCheckboxes),
    };
    if (selectedCheckboxes?.size === 0) {
      if (initialCheckboxesState?.size > 0) {
        try {
          await dispatch(
            deleteUserRolePermissionAPI(
              userRole?.user_id,
              (isSuccess, response) => {
                if (isSuccess?.status === true) {
                  toast.success(response?.data);
                  navigate("/userRolePermissionList");
                } else {
                  const errorMessage =
                    response?.error || "Something went wrong.";
                  toast.error(errorMessage);
                }
              }
            )
          );
        } catch (error) {
          console.log("Error dispatching deleteUserRolePermissionAPI:", error);
          toast.error("Something went wrong.");
        }
      } else {
        toast.error("Please select one checkbox.");
      }
    } else {
      const userRolePermissionApiCall = isEdit
        ? updateUserRolePermissionAPI
        : addUserRolePermissionAPI;
      try {
        await dispatch(
          userRolePermissionApiCall(
            addRolePermissionRequestData,
            (isSuccess, response) => {
              if (isSuccess?.status === true) {
                toast.success(response?.data);
                navigate("/userRolePermissionList");
              } else {
                const errorMessage =
                  response?.error || Strings.somethingWentWrongError;
                toast.error(errorMessage);
              }
            }
          )
        );
      } catch (error) {
        console.log("Error dispatching addRolePermissionAPI:", error);
        toast.error(Strings.somethingWentWrongError);
      }
    }
  };

  return (
    <div style={mainContainerStyle}>
      <LeftSideNav />
      <div style={topContainerStyle}>
        <TopNavBar />
        <BreadcrumbsComponent breadcrumbs={breadcrumbs} />
        <div style={tableContainerStyle}>
          <div style={outerWrapper}>
            <div
              style={{
                textAlign: "center",
                backgroundColor: Colors.adminPrimaryColor,
                width: "100%",
                color: Colors.white,
                borderTopLeftRadius: "20px",
                borderTopRightRadius: "20px",
                padding: "8px 8px",
              }}
            >
              Permissions
            </div>
            <div style={tableWrapper}>
              <table style={table}>
                <thead style={{borderBottom: '1px solid #e6e6e6'}}>
                  <th style={tableLabelText}>
                    Module Name
                  </th>
                  {rolePermissionTableHeader?.map((tCell, index) => (
                    <th key={index} style={tableLabelText}>
                      {tCell?.header}
                    </th>
                  ))}
                </thead>
                <tbody>
                  {userRoleModuleName?.map((module, moduleIndex) => (
                    <tr key={moduleIndex}>
                      <td style={tableInputTxtStyle}>{module?.module_name}</td>
                      {rolePermissionTableHeader?.map((_, roleIndex) => {
                        const simpleId = getCheckboxValue(
                          moduleIndex,
                          roleIndex
                        );
                        return (
                          <td key={simpleId} style={{borderBottom: "1px solid #E6E6E6",}}>
                            <Checkbox
                              size="medium"
                              id={simpleId}
                              checked={selectedCheckboxes.has(simpleId)}
                              onChange={(event) =>
                                handleCheckboxChange(
                                  event,
                                  moduleIndex,
                                  roleIndex
                                )
                              }
                              sx={{
                                // Unchecked state
                                "& .MuiSvgIcon-root": {
                                  color: "#363740", // Set the icon color when unchecked
                                  borderRadius: "2px", // Optional: border-radius for rounded corners
                              
                                },
                                // Checked state
                                "&.Mui-checked .MuiSvgIcon-root": {
                                  color: "#363740", // Change the icon color when checked
                        
                                },
                              }}
                            />
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>

            <div style={{marginTop: '15px'}}>
            <CustomButton
                label={Strings.Save}
                handleSubmit={onAddRolePermission}
              />
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Styling objects (adapt as needed)
const mainContainerStyle = {
  display: "grid",
  gridTemplateColumns: "20% 85%",
  height: "100vh",
  width: "100vw",
  overflow: "hidden", // Hide all overflow
};

const topContainerStyle = {
  backgroundColor: Colors.bgColor,
  display: "flex",
  flexDirection: "column",
  height: "100%",
  width: "94%",
};

const tableContainerStyle = {
  backgroundColor: "white",
  paddingTop: "20px",
  width: "96%",
  marginTop: "15px",
  marginLeft: "20px",
  height: "80%",
};

const outerWrapper = {
  borderRadius: "12px",
  height: "100%",
  width: "55%",
  backgroundColor: Colors.white,
  marginLeft: "30px",
  borderTopLeftRadius: "20px",
  borderTopRightRadius: "20px",
};

const tableWrapper = {
  overflowY: "hidden",
  overflowX: "hidden",
  height: "96%",
};

const table = {
  minWidth: "100%",
  borderCollapse: "separate",
  borderSpacing: "0px",
  border: "1px solid #ccc",
  borderBottomLeftRadius: "20px",
  borderBottomRightRadius: "20px",
};

const tableLabelText = {
  fontSize: 12,
  fontWeight: "500",
  fontFamily: Fonts.Poppins,
  color: Colors.breadCrumbsColor,
  position: "sticky",
  top: 0,
  padding: '10px 10px',
  textAlign: "center",
  borderRight: 'none',
  borderBottom: "1px solid #E6E6E6",
};

const tableInputTxtStyle = {
  fontSize: 12,
  fontWeight: "500",
  fontFamily: Fonts.Poppins,
  color: Colors.black,
  borderBottom: "1px solid #E6E6E6",
};

export default UserRolePermissionModuleList;
